import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-primary text-cream py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Logo variant="light" />
            <p className="mt-4 text-sm text-cream/70">
              Профессиональная школа маникюра
            </p>
            <div className="mt-4 text-xs text-cream/50 space-y-0.5">
              <p>ИП Волкова Д.М</p>
              <p>ИНН 771595682031</p>
              <p>ОГРНИП 316774600189657</p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-4">Навигация</h4>
            <ul className="space-y-2 text-sm text-cream/70">
              <li>
                <Link to="/courses" className="hover:text-cream transition-colors">
                  Курсы
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="hover:text-cream transition-colors">
                  Расписание
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-cream transition-colors">
                  О нас
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-cream transition-colors">
                  Контакты
                </Link>
              </li>
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="font-semibold mb-4">Обучение</h4>
            <ul className="space-y-2 text-sm text-cream/70">
              <li>
                <Link to="/courses" className="hover:text-cream transition-colors">
                  Групповые курсы
                </Link>
              </li>
              <li>
                <Link to="/individual" className="hover:text-cream transition-colors">
                  Индивидуальное обучение
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cream transition-colors">
                  Онлайн-курсы
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Контакты</h4>
            <ul className="space-y-2 text-sm text-cream/70">
              <li>
                <a
                  href="https://wa.me/79652339933"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  +7 (965) 233-99-33
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/kastalianail_school"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  Telegram
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/kastalia.pro/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://vk.com/kastalia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  ВКонтакте
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/20 text-center text-sm text-cream/50">
          <p>&copy; {new Date().getFullYear()} КАСТАЛИЯ НЕЙЛС. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}
